import PlanejamentoAcaoModalNovaAcao from '../../../produto/spa/planejamento-acao/list/PlanejamentoAcaoModalNovaAcao';

export default PlanejamentoAcaoModalNovaAcao;
